<!--模板-->
<template>
  <div id="authenticate">
    <el-row :gutter="0" class="dashed">
      <el-col :span="12">
        <div class="grid-content bg-purple title1">认证成为-陪陪服务者</div>
      </el-col>
    </el-row>
    <!--    认证-->
    <el-row v-if="UserProof　&& UserProof.checkStatus == 0 ">
      <el-form ref="form" label-width="100px">
        <el-form-item label="真实姓名：" prop="title">
          <el-col :span="10">
            <el-input v-model="nameData" placeholder="请输入真实姓名" maxlength="5"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="证件类型：" prop="title">
          <el-col :span="10">
            <el-select v-model="certificateIndex" placeholder="请选择证件类型">
              <el-option v-for="item in certificateList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="证件号码：" prop="title">
          <el-col :span="10">
            <el-input v-model="credentials" placeholder="请输入证件号码" maxlength="26"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="证件照：" prop="title">
          <p>（必传）上传证件照片*照片仅用于认证，请确保图片清晰可见，见右图示例</p>
          <el-col :span="12">
            <el-upload class="upload-demo" drag action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS" :show-file-list="false" :on-exceed="handleExceed" :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload" multiple>
              <div v-if="nameImg == ''">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </div>
              <img v-if="nameImg" style="width: 100%;height: 100%" :src="nameImg" height="180" width="300" />
            </el-upload>
          </el-col>
          <el-col :span="12">
            <img style="margin-left: 50px" v-if="certificateIndex == 0 || certificateIndex == ''" src="https://pbw-uploadfile.oss-cn-beijing.aliyuncs.com/home/pcIcon/shenfenzheng.jpg" height="180" width="300" />
            <img style="margin-left: 50px" v-if="certificateIndex == 1" src="https://pbw-uploadfile.oss-cn-beijing.aliyuncs.com/home/pcIcon/xueshengzheng.jpg" height="180" width="300" />
            <img style="margin-left: 50px" v-if="certificateIndex == 2" src="https://pbw-uploadfile.oss-cn-beijing.aliyuncs.com/home/pcIcon/huzhao.jpg" height="180" width="300" />
          </el-col>
        </el-form-item>
               <el-form-item label="形象照：" prop="title">
            <p>(可选)上传本人宣传形象照 *要求手持官方LOGO纸样，见右图示例</p>
            <el-col :span="12" v-if="showImg == ''">
              <el-upload class="upload-demo" drag action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS" :show-file-list="false" :on-exceed="handleExceed" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload" multiple>
                <div v-if="showImg == ''">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </div>
                <img v-if="showImg" style="width: 100%;height: 100%" :src="showImg" height="180" width="300" />
              </el-upload>
            </el-col>
            <el-col :span="12">
              <img style="margin-left: 50px" src="https://pbw-uploadfile.oss-cn-beijing.aliyuncs.com/home/pcIcon/xuanchuan.jpg" height="180" width="300" />
            </el-col>
          </el-form-item>
        <div class="allshow" v-if="!allShow" @click="allShow = true">补充更多资料+ >></div>
        <div v-if="allShow">
            <el-form-item label="导游证号：" prop="title">
          <el-col :span="10">
            <el-input v-model="tourist" placeholder="请输入导游证号（选填）"></el-input>
          </el-col>
        </el-form-item>
          <el-form-item label="导游证件：" prop="title">
            <p>(可选)上传导游证 *如您有导游证(新版旧版证均可)，见右图示例</p>
            <el-col :span="12">
              <el-upload class="upload-demo" drag action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS" :show-file-list="false" :on-exceed="handleExceed" :on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload" multiple>
                <div v-if="touristImg == ''">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                </div>
                <img v-if="touristImg" style="width: 100%;height: 100%" :src="touristImg" height="180" width="300" />
              </el-upload>
            </el-col>
            <el-col :span="12">
              <img style="margin-left: 50px" src="https://pbw-uploadfile.oss-cn-beijing.aliyuncs.com/home/pcIcon/daoyou.jpg" height="180" width="300" />
            </el-col>
          </el-form-item>
          <el-form-item label="其它证件：" prop="title">
            <p>(可选)其他证件 *如您有其他证件，可上传增加审核通过率和客户下单率</p>
            <el-col :span="24">
              <div style="display: flex;justify-content: space-around">
                <img v-for="(item,index) of otherList" :key="index" :src="item" height="130" width="200" />
              </div>
              <p style="text-align: center;margin: 10px" v-if="otherList.length < 3">
                <el-upload class="upload-demo" drag action="https://api.peibanwan.com/pbw-interface/common/uploadFileToOSS" :show-file-list="false" :on-exceed="handleExceed" :on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload" multiple>
                  <div>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </div>
                </el-upload>
              </p>
            </el-col>
          </el-form-item>
          <div class="allshow" v-if="allShow" @click="allShow = false">收起更多资料>></div>
        </div>
        <p style="text-align: center;">
          <el-button type="primary" @click="addBtn()"> 提 交 认 证 </el-button>
        </p>
      </el-form>
    </el-row>
    <!--    状态-->
    <div class="statck" v-if="UserProof.checkStatus != 0 ">
      <img src="/static/images/empty.png" style="width: 250px" alt="">
      <div v-if="UserProof.checkStatus == 1">
        <h5  style="margin:30px 0">认证正在审核中，我们正在加紧处理...（我们会短信通知您结果），您可先进行发布技能服务！</h5>
        <p style="text-align: center;margin-top:10px;">
          <el-button type="primary" @click="$router.push('/home/services/service')"> 抢先发布技能服务 </el-button>
        </p>
      </div>
      <div v-if="UserProof.checkStatus == 2">
        <h5 style="margin:30px 0">您已实名认证成功，可前往发布服务技能...</h5>
        <p style="text-align: center;">
          <el-button type="primary" @click="$router.push('/home/services/service')"> 抢先发布技能服务 </el-button>
        </p>
      </div>
      <div v-if="UserProof.checkStatus == 3">
        <h5 style="margin:30px 0">您的认证审核失败，（原因：{{UserProof.refuseText}}）</h5>
        <p style="text-align: center;">
          <el-button type="primary" @click="UserProof.checkStatus = 0"> 重新认证 </el-button>
        </p>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
  import {
    insertUserProof,
    selectUserProof,
  } from "api/apis";
  export default {
    data() {
      return {
        allShow: false,
        title: '',
        certificateList: [{
          value: '0',
          label: '身份证'
        }, {
          value: '1',
          label: '学生证'
        }, {
          value: '2',
          label: '护照'
        }],
        certificateIndex: '',
        nameData: '',
        credentials: '',
        tourist: '',
        otherList: [],
        UserProof: '',
        checkShow: false,
        nameImg: '',
        showImg: '',
        touristImg: ''
      };
    },
    methods: {
      addBtn() {
        let vm = this
        if (vm.nameData == '') {
          vm.$message.warning('请填写真实姓名')
          return
        }
        if (vm.certificateIndex == '') {
          vm.$message.warning('请选择证件类型')
          return
        }
        if (vm.credentials == '') {
          vm.$message.warning('请输入正确证件号码')
          return
        }
        if (vm.nameImg == '') {
          vm.$message.warning('请上传证件照片')
          return
        }
        // 认证信息
        insertUserProof({
          userCode: localStorage.getItem('pbw_user_pc_uid'),
          proofImgPath: vm.nameImg,
          userImgPath: vm.showImg,
          guideImgPath: vm.touristImg,
          otherImgPath: vm.otherList.join(','),
          realName: vm.nameData,
          proofType: vm.certificateIndex,
          proofNumber: vm.credentials,
          guideNumber: vm.tourNum,
        }).then((res) => {
          if (res.code == '000000') {
            vm.$message.success('认证已提交')
            vm.getUserProof()
          } else {
            vm.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      },
      handleExceed(files, fileList) { //限制图片上传几个
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      handleAvatarSuccess1(res, file, fileList) { //图片上传成功
        console.log(fileList[0].response.data.ossFileName, "回传成功")
        this.nameImg = fileList[0].response.data.ossFileName
      },
      handleAvatarSuccess2(res, file, fileList) { //图片上传成功
        console.log(fileList[0].response.data.ossFileName, "回传成功")
        this.showImg = fileList[0].response.data.ossFileName
      },
      handleAvatarSuccess3(res, file, fileList) { //图片上传成功
        console.log(fileList[0].response.data.ossFileName, "回传成功")
        this.touristImg = fileList[0].response.data.ossFileName
      },
      handleAvatarSuccess4(res, file, fileList) { //图片上传成功
        console.log(fileList[0].response.data.ossFileName, "回传成功")
        this.otherList.push(fileList[0].response.data.ossFileName)
      },
      beforeAvatarUpload(file) {
        // 上传格式判断
        if (!/.(jpg|jpeg|png|bmp|JPG|JPEG|PNG|BPM)$/.test(file.name)) {
          this.$message.error('文件格式只能是jpeg、jpg、PNG、bmp中的一种!')
          return false
        }
        if (file.size > 100 * 1024 * 1024) {
          this.$message.error('文件大小超过限制')
          return false
        }
        const loading = this.$loading({
          lock: true,
          text: '上传中～',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 1500);
      },
      getUserProof() {
        let vm = this
        // 获取认证信息
        selectUserProof({
          uid: localStorage.getItem('pbw_user_pc_uid')
        }).then((res) => {
          if (res.code == '000000') {
            vm.UserProof = res.data
          } else {
            vm.$message.warning(res.msg ? res.msg : '数据加载中，请稍后')
          }
        })
      }
    },
    mounted() {
      // 获取认证
      this.getUserProof()
      if(this.$route.query.type){
          this.allShow = true
      }
    }
  };
</script>


<!--css样式-->
<style lang="scss" scoped>
  @import '../../../src/scss/commonH5.scss';
  .allshow{
    padding: 5px 0;
    text-align: center;
    color: #f60;
    font-weight: bold;
    font-size: 20px;
    border: 1px solid #f60;
    width: 600px;
    margin: 30px auto ;
    cursor: pointer;
  }
  .statck {
    height: 500px;
    text-align: center;
    img {}
  }
  .avatar {
    height: 120px;
    border-radius: 90px;
    border: 1px solid #d6d6d6;
  }
  #authenticate .dashed {
    border-bottom: 1px dashed #F1F1F1;
    padding-bottom: 20px;
    margin-bottom: 25px;
  }
  #authenticate .title1 {
    font-size: 18px;
    color: #333;
  }
  #authenticate .title1::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 27px;
    border-radius: 5px;
    vertical-align: bottom;
    background-color: #F16202;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/authenticate.vue